import { SiteUrls } from '@tableau/shared-urls';
import { CheckBoxWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FlowWithRunPermission } from '~src/flow/serverApi/requests/GetFlowsWithRunPermissionsRequest';
import { LinkedTaskCellStyles } from '~src/linkedTasks/styles/LinkedTaskCellStyles';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';
import { classes } from '~src/style';

const INFO_ICON_IMG_PATH = imgPath('info_14px_small.svg');
const FLOW_ICON_IMG_PATH = imgPath('spaces_small_flow.svg');


const handleCheckboxClick = (e: React.SyntheticEvent<HTMLInputElement, Event>) => {
  // let handleCellClick handle click events
  e.preventDefault();
};

const handleLinkClick = (e: React.SyntheticEvent<HTMLAnchorElement, Event>) => {
  // navigate to link but don't let handleCellClick get the event
  e.stopPropagation();
};

function renderDisabledInfoToolip() {
  return (
    <Tooltip
      position={TooltipPosition.Right}
      getContent={getTooltipContent}
      maxWidth={220}
    >
      <img className={LinkedTaskCellStyles.InfoIcon} src={INFO_ICON_IMG_PATH} alt={''} />
    </Tooltip>
  );
}

function renderFlowCellGoToButton(flowId: string, siteUrls: SiteUrls) {
  return (
    <a
      className={classes(LinkedTaskCellStyles.ContentItem, LinkedTaskCellStyles.FlexShrinkZero, LinkedTaskCellStyles.LinkButton)}
      onClick={handleLinkClick}
      href={siteUrls.flowOverviewUrl(flowId)}
      title={Messages.linkedTasksGoToFlow()}
      rel={'noreferrer'}
      target= {'_blank'}>
        <img className={LinkedTaskCellStyles.LinkImg} src={imgPath('goto_generic_14px-small.svg')} alt={''} />
    </a>
  );
}

export function renderPrimaryFlowItem(flowName: string, flowId: string, isDisabled: boolean, siteUrls: SiteUrls) {
  return (
    <div className={LinkedTaskCellStyles.InnerTextWrapper}>
      <img src={FLOW_ICON_IMG_PATH} className={classes(LinkedTaskCellStyles.ItemIcon, LinkedTaskCellStyles.FlexShrinkZero, isDisabled ? LinkedTaskCellStyles.Disabled : null)} alt={Messages.flow()} />
      <div className={classes(LinkedTaskCellStyles.ContentItem,  LinkedTaskCellStyles.FlexShrinkZero, isDisabled ? LinkedTaskCellStyles.Disabled : null)}>{Messages.linkedTasksRunFlowSentenceCasing()}</div>
      <div title={flowName} className={classes(LinkedTaskCellStyles.ContentItem, LinkedTaskCellStyles.ContentName, isDisabled ? LinkedTaskCellStyles.Disabled : null)}>{flowName}</div>
      {isDisabled && renderDisabledInfoToolip()}
      {renderFlowCellGoToButton(flowId, siteUrls)}
    </div>
  );
}

const getTooltipContent = () => <span>{Messages.linkedTaskPermissionsInfoTooltip()}</span>;

export function SelectFlowCell(isSelected: (id: string) => boolean, onItemSelectionToggle: (row: DataGrid.Row) => void, siteUrls: SiteUrls): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    function SelectFlowCell(props: BodyCell.Props) {
      const flow: FlowWithRunPermission = props.row.data as FlowWithRunPermission;
      const isDisabled: boolean = !flow.userHasRunPermissions;

      const handleCellClick = (e: React.SyntheticEvent<HTMLDivElement, Event>) => {
        if (!isDisabled) {
          onItemSelectionToggle(props.row);
        }
        e.preventDefault();
        e.stopPropagation();
      };

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <div
          onClick={handleCellClick}
          key={flow.id}
          className={classes(LinkedTaskCellStyles.Wrapper)}
          data-tb-test-id={'SelectFlowCellTestId'}
        >
          <div className={LinkedTaskCellStyles.CheckboxWrapper}>
            <CheckBoxWidget
              checked={isSelected(flow.id)}
              handleChange={() => onItemSelectionToggle(props.row)}
              testId={'SelectFlowCellCheckboxTestId'}
              removeLeftMargin={true}
              onClick={handleCheckboxClick}
              disabled={isDisabled}
            />
          </div>
          <div className={LinkedTaskCellStyles.TextWrapper}>
            {renderPrimaryFlowItem(flow.name, flow.id, isDisabled, siteUrls)}
          </div>
        </div>
      );
    }
  );
}
